import { createContext, PropsWithChildren, useContext, useState } from "react";

export type IManualSubscriptionContext = {
	officeId: string;
	setOfficeId: (id: string) => void;
	cgpId: string;
	setCgpId: (id: string) => void;
	clientSheetId: string;
	setClientSheetId: (id: string) => void;
	isCoSubscription: boolean;
	setIsCoSubscription: (isCoSubscription: boolean) => void;
};

type IProps = PropsWithChildren<{}>;

export const ManualSubscriptionContext = createContext<IManualSubscriptionContext>(undefined!);

export function ManualSubscriptionProvider(props: IProps) {
	const [officeId, setOfficeId] = useState<string>("");
	const [cgpId, setCgpId] = useState<string>("");
	const [clientSheetId, setClientSheetId] = useState<string>("");
	const [isCoSubscription, setIsCoSubscription] = useState<boolean>(false);

	return (
		<ManualSubscriptionContext.Provider value={{ officeId, setOfficeId, cgpId, setCgpId, clientSheetId, setClientSheetId, isCoSubscription, setIsCoSubscription }}>
			{props.children}
		</ManualSubscriptionContext.Provider>
	);
}

export const useManualSubscriptionContext = () => {
	const context = useContext(ManualSubscriptionContext);
	if (!context) {
		throw new Error("useManualSubscriptionContext must be used within a ManualSubscriptionProvider");
	}
	return context;
};
